import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import TopBarProgress from "react-topbar-progress-indicator";
import { getFilterGrouping } from "../../../actions/filters";
import { useDispatch } from "react-redux";
import { retreive, edit } from "../../../actions/subCategory";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Alert from "../../../components/alert/alert.component";
import { getSecondLevelCategories } from "../../../services/categories/second-level-categories.service";
import HeadingPrimary from "../../../components/custom-heading/heading-primary";
import HeadingSecondary from "../../../components/custom-heading/heading-secondary";
import CustomInput from "../../../components/custom-input/custom-input";
import CustomTextArea from "../../../components/custom-input/custom-textarea";
import CustomRadioInput from "../../../components/custom-input/custom-radio-input";
import CustomButton, {
  CustomButtonClasses,
  CustomButtonTypes,
} from "../../../components/custom-button/custom-button";
import MultiValueSelect from "../main-category/components/multi-value-select/multi-value-select";
import ImageUploaderField from "../../../components/img-uploader-field/img-uploader-field";
import SubCategoryDropDown from "./components/sub-category-drop-down";

const Edit = () => {
  const query = new URLSearchParams(window.location.search);
  const id = query.get("id");
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(true);
  const [parentCategory, setParentCategory] = useState({});
  const [formData, setFormData] = useState({
    name: "",
    displayName: "",
    slug: "",
    description: "",
    metaTag: [],
    metaDescription: "",
    metaKeyword: [],
    seoKeyword: [],
    childCategories: null,
    childCategoriesId: "",
    show: true,
    filterOptions: [],
    filter: [],
    serverSideFilterOptions: [],
    isbase64: false,
    banner: "",
    isBannerBase64: false,
  });

  useEffect(() => {
    const fetchData = async () => {
      const _res = await getSecondLevelCategories();
      setFormData((prevFormData) => ({
        ...prevFormData,
        childCategories: _res?.data,
      }));

      const res = await dispatch(retreive(id));

      const res1 = await getFilterGrouping();
      const filteredData = [];

      res1?.data?.map((item) => {
        filteredData?.push({
          value: item._id,
          label: item.title,
          isFixed: item.status,
        });
      });

      setFormData((prevFormData) => ({
        ...prevFormData,
        serverSideFilterOptions: filteredData,
      }));

      const metaTagData = [];

      res?.metaTag &&
        res?.metaTag?.forEach((element) => {
          metaTagData?.push({ value: element, label: element });
        });

      const metaKeywordData = [];

      res?.metaKeyword &&
        res.metaKeyword.forEach((_element) => {
          metaKeywordData?.push({ value: _element, label: _element });
        });

      const seoKeywordData = [];

      res?.seoKeyword &&
        res?.seoKeyword?.forEach((element) => {
          seoKeywordData.push({ value: element, label: element });
        });

      const filterOptionsData = [];

      res?.filter?.forEach((filter_id) => {
        formData?.serverSideFilterOptions?.forEach((filter) => {
          if (filter?.value === filter_id) {
            filterOptionsData.push({
              value: filter.value,
              label: filter.label,
              isFixed: filter.isFixed,
            });
          }
        });
      });

      setFormData((prevFormData) => ({
        ...prevFormData,
        childCategoriesId: res?.categoryId,
        banner: res?.banner,
        name: res?.name,
        displayName: res.displayName,
        slug: res.slug,
        description: res.description,
        metaTag: metaTagData,
        metaDescription: res.metaDescription,
        metaKeyword: metaKeywordData,
        seoKeyword: seoKeywordData,
        show: res.show,
        image: res.image,
        filterOptions: filterOptionsData,
      }));
      const getParentCategory = _res?.data.filter(
        (item) => item._id === res?.categoryId
      )[0];
      setParentCategory(getParentCategory);
      setLoading(false);
    };

    fetchData();
    return () => setLoading(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleImageChange = async (e) => {
    const base64Image = await toBase64(e[0]);
    setFormData((prevFormData) => ({
      ...prevFormData,
      image: base64Image,
      isbase64: true,
    }));
  };

  const handleImageBannerChange = async (e) => {
    const base64Image = await toBase64(e[0]);
    setFormData((prevFormData) => ({
      ...prevFormData,
      banner: base64Image,
      isBannerBase64: true,
    }));
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const submitHandler = async () => {
    setLoading(true);
    const {
      name,
      slug,
      displayName,
      image,
      description,
      metaTag,
      metaDescription,
      metaKeyword,
      seoKeyword,
      show,
      filterOptions,
      isbase64,
      banner,
      childCategoriesId,
      isBannerBase64,
    } = formData;

    const metaTagData = [];

    metaTag.forEach((element) => {
      metaTagData.push(element.value);
    });

    const metaKeywordData = [];

    metaKeyword.forEach((_element) => {
      metaKeywordData.push(_element.value);
    });

    const seoKeywordData = [];

    seoKeyword.forEach((element) => {
      seoKeywordData.push(element.value);
    });

    const filterOptionData = [];
    filterOptions.forEach((element) => {
      filterOptionData.push(element.value);
    });

    let sendData = {
      name: name,
      displayName,
      categoryId: childCategoriesId,
      slug: slug,
      _id: id,
      image: image,
      metaTag: metaTagData,
      metaDescription: metaDescription,
      metaKeyword: metaKeywordData,
      seoKeyword: seoKeywordData,
      description: description,
      show: show,
      isbase64,
      banner,
      isBannerBase64,
    };

    const res = await dispatch(edit(sendData));

    setLoading(false);

    if (res) {
      toast(`${res.data}`, { containerId: "B" });
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const changeInputTags = (e, key) => {
    const data = e?.map((item) => ({
      value: item.value,
      label: item.value,
    }));
    setFormData((prev) => ({ ...prev, [key]: data }));
  };

  const getCategoriesTree = () =>
    Array.isArray(formData.childCategories) &&
    formData.childCategories?.map((item, index) => (
      <option
        selected={item?._id === formData.selectedId}
        key={item?._id ?? index}
        value={item._id}
      >
        {`${item?.maincategory?.name ?? ""} >  ${item?.name ?? ""} `}
      </option>
    ));

  TopBarProgress.config({
    barThickness: 4,
    barColors: {
      0: "rgb(51, 201, 45, .7)",
      ".3": "rgb(255, 77, 107, .7)",
      "1.0": "rgb(200, 125, 255, .7)",
    },
    shadowBlur: 5,
    shadowColor: "rgba(0, 0, 0, .5)",
  });

  return (
    <div className="container-scroller">
      {loading && <TopBarProgress />}

      <ToastContainer
      stacked 
        enableMultiContainer
        containerId={"B"}
        // position={toast.POSITION.TOP_RIGHT}
          position="top-right" // Hardcoded position
      />

      <div className="page-header">
        <HeadingPrimary>Edit Sub Category</HeadingPrimary>

        <div style={{ fontSize: ".9rem" }}>
          <Link to="/admin/sub-categories">Sub Categories </Link>
          /&nbsp;Edit Sub Category
        </div>
      </div>

      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div
            className="card p-0"
            style={{
              border: "1px solid #dcdcdc",
            }}
          >
            <div className="card-body p-0">
              <HeadingSecondary>Edit Sub Category</HeadingSecondary>
              <Alert />

              <form className="forms-sample m-3">
                <CustomInput
                  label="Name"
                  name="name"
                  type="text"
                  placeholder="Name"
                  labelStyles={{ fontWeight: "bold" }}
                  onChange={handleChange}
                  value={formData?.name}
                />

                <CustomInput
                  label="Display Name"
                  name="displayName"
                  type="text"
                  placeholder="Name"
                  labelStyles={{ fontWeight: "bold" }}
                  onChange={handleChange}
                  value={formData.displayName}
                />

                <CustomInput
                  label="Slug"
                  name="slug"
                  type="text"
                  placeholder="Slug"
                  labelStyles={{ fontWeight: "bold" }}
                  onChange={handleChange}
                  value={formData.slug}
                />

                <SubCategoryDropDown
                  label="Select parent category"
                  id="category"
                  getOptions={getCategoriesTree}
                  name="childCategoriesId"
                  labelStyles={{ fontWeight: "bold" }}
                  handleImageChange={handleChange}
                  value={parentCategory}
                />

                <ImageUploaderField
                  labelStyles={{ fontWeight: "bold" }}
                  label="Image upload"
                  buttonText="Choose image"
                  name="image"
                  onChange={(e) => handleImageChange(e)}
                />

                <div className="input-group col-xs-12">
                  <img
                    src={formData?.image && formData?.image}
                    alt=""
                    width="100"
                    height="50"
                    style={{ marginBottom: "2rem" }}
                  />
                </div>

                <ImageUploaderField
                  labelStyles={{ fontWeight: "bold" }}
                  label="Banner upload"
                  buttonText="Choose image"
                  name="banner"
                  onChange={(e) => handleImageBannerChange(e)}
                />

                <div className="input-group col-xs-12">
                  <img
                    src={formData?.banner && formData?.banner}
                    alt="banner"
                    width="100"
                    height="50"
                    style={{ marginBottom: "2rem" }}
                  />
                </div>

                {!loading && (
                  <MultiValueSelect
                    label="Meta Tags"
                    defaultValue={formData.metaTag}
                    name="metaTags"
                    labelStyles={{ fontWeight: "bold" }}
                    onChange={(value) => changeInputTags(value, "metaTag")}
                  />
                )}

                {!loading && (
                  <MultiValueSelect
                    label="Meta Keywords"
                    defaultValue={formData.metaKeyword}
                    name="metaKeyword"
                    labelStyles={{ fontWeight: "bold" }}
                    onChange={(value) => changeInputTags(value, "metaKeyword")}
                  />
                )}

                <CustomTextArea
                  label="Meta Description"
                  labelStyles={{ fontWeight: "bold" }}
                  name="metaDescription"
                  rows={6}
                  value={formData.metaDescription}
                  onChange={handleChange}
                />

                {!loading && (
                  <MultiValueSelect
                    label="Seo Keywords"
                    defaultValue={formData.seoKeyword}
                    name="seoKeyword"
                    onChange={(value) => changeInputTags(value, "seoKeyword")}
                  />
                )}

                <CustomTextArea
                  label="Seo Description"
                  labelStyles={{ fontWeight: "bold" }}
                  name="description"
                  rows={6}
                  value={formData.description}
                  onChange={handleChange}
                />

                <div className="form-group ">
                  <label
                    style={{ fontWeight: "bold" }}
                    className="col-sm-3 col-form-label"
                  >
                    Show in Header
                  </label>
                  <div className="col-sm-12">
                    <CustomRadioInput
                      label="Yes"
                      required={true}
                      type="radio"
                      id="radio1"
                      name="membershipRadios"
                      checked={formData?.show === true}
                      labelStyles={{ fontWeight: "bold" }}
                      value={formData.show}
                      onChange={() => setFormData({ ...formData, show: true })}
                    />
                  </div>

                  <div className="col-sm-5">
                    <CustomRadioInput
                      label="No"
                      required={true}
                      type="radio"
                      name="membershipRadios"
                      id="radio2"
                      checked={formData?.show === false}
                      labelStyles={{ fontWeight: "bold" }}
                      value={formData.show}
                      onChange={() => setFormData({ ...formData, show: false })}
                    />
                  </div>
                </div>
                <CustomButton
                  type={CustomButtonTypes.BUTTON}
                  className={CustomButtonClasses.PRIMARY}
                  onClick={submitHandler}
                >
                  Update
                </CustomButton>
                <Link to={"/admin/sub-categories"}>
                  <CustomButton
                    className={CustomButtonClasses.LIGHT}
                    type={CustomButtonTypes.BUTTON}
                  >
                    Cancal
                  </CustomButton>
                </Link>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Edit;
